import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/AboutUs";
import Properties from "./pages/Properities";
import Requirements from "./pages/Requirements";
import Rent from "./pages/Rent";
import ContactUs from "./pages/ContactUs";
import ApplyNow from "./pages/ApplyNow";
import TenantApplicationWizard from "./pages/TenantApplicationWizard";
import AgentPage from "./pages/AgentPage";
import PropertyDetail from "./pages/PropertyDetailPage";
import Login from "./pages/Login";
import AdminRoutes from "./admin";

function AppShell() {
  const location = useLocation();

  // hide Header/Footer for login or admin routes
  const hideChrome =
    location.pathname.startsWith("/admin") ||
    location.pathname === "/login";

  return (
    <div className="App bg-gray-50 min-h-screen flex flex-col">
      <ScrollToTop />
      {!hideChrome && <Header />}

      <main className="flex-grow">
        <Routes>
          {/* ---- Public routes ---- */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/requirements" element={<Requirements />} />
          <Route path="/rent" element={<Rent />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/apply" element={<ApplyNow />} />
          <Route path="/apply-to-rent" element={<TenantApplicationWizard />} />
          <Route path="/agent" element={<AgentPage />} />
          <Route path="/properties/:slug" element={<PropertyDetail />} />

          {/* ---- Admin (React SPA) ---- */}
          <Route path="/login" element={<Login />} />
          <Route path="/admin/*" element={<AdminRoutes />} />
        </Routes>
      </main>

      {!hideChrome && <Footer />}
    </div>
  );
}

export default AppShell;
